<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- Header & Actions -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "business" | transloco }}</span>
        <h2 class="bb-page-title">{{ "business" | transloco }}</h2>
        @if(superAdmin){
        <p class="bb-page-subtitle">{{ "total business" | transloco }}</p>
        }
      </div>

      <div class="bb-header-actions">
        @if(superAdmin){
          <button routerLink="/createpos" class="bb-btn bb-btn-primary bb-btn-wide">
            {{ 'Create new business' | transloco }}
          </button>
        }

        @if(isblueboxMain && superAdmin){
          <button [routerLink]="isMobile ? '/e-commerce.mobile' : '/e-commerce'" class="bb-btn bb-btn-secondary">
            {{ 'e-commerce manager' | transloco }}
            <span class="bb-badge bb-badge-soft-blue">{{ 'BlueBox' | transloco }}</span>
          </button>
        }
      </div>
    </header>

    <!-- Summary -->
    @if(superAdmin){
    <div class="bb-filter-card">
      <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <div class="bb-text-stack">
          <strong class="bb-text-navy bb-font-bold">{{ "total business" | transloco }}</strong>
          <small class="bb-text-muted">{{ "egp" | transloco }}</small>
        </div>

        <strong class="bb-page-title">
          {{ formatMoney(totalGoodsValue) }}
        </strong>
      </div>
    </div>
    }

    <!-- Business Table -->
    <div class="bb-table-card bb-p-16">
      <div class="bb-table-scroll">
        <table mat-table [dataSource]="dataSource" class="bb-table">

          <!-- IMAGE -->
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef>
              {{ "image" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div class="bb-product-img-box">
                <img
                  [src]="element.image_url || '/assets/logo-01.png'"
                  [alt]="getPosName(element)"
                />
              </div>
            </td>
          </ng-container>

          <!-- NAME -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div class="bb-text-stack">
                <strong class="bb-text-navy bb-font-bold">
                  {{ getPosName(element) }}
                </strong>

                @if(activePosId == element.id){
                  <span class="bb-badge bb-badge-success">
                    {{ "selected" | transloco }}
                  </span>
                }
              </div>
            </td>
          </ng-container>

          <!-- LOCATION -->
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>
              {{ "business location" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              {{ element.location }}
            </td>
          </ng-container>

          <!-- TOTAL -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef>
              {{ "total business" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <strong class="bb-price bb-text-blue">
                {{ formatMoney(element.total_value) }}
              </strong>

              @if(hasTotalValue(element.total_value)) {
                <span class="bb-text-muted bb-font-semibold">
                  {{ "egp" | transloco }}
                </span>
              }
            </td>
          </ng-container>

          <!-- TYPE -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>
              {{ "business type" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div [ngSwitch]="element.warehouses_type">
                <span *ngSwitchCase="'0'" class="bb-badge bb-badge-soft-blue">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'company' | transloco }}
                </span>
                <span *ngSwitchCase="'1'" class="bb-badge bb-badge-soft-cyan">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'warehouse' | transloco }}
                </span>
                <span *ngSwitchCase="'2'" class="bb-badge bb-badge-primary">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'store' | transloco }}
                </span>
                <span *ngSwitchCase="'3'" class="bb-badge bb-badge-success">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'clinic' | transloco }}
                </span>
                <span *ngSwitchCase="'4'" class="bb-badge bb-badge-warning">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'store and clinic' | transloco }}
                </span>
                <span *ngSwitchCase="'5'" class="bb-badge bb-badge-soft-blue">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'shipping' | transloco }}
                </span>
                <span *ngSwitchDefault class="bb-badge bb-badge-danger">
                  <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                  {{ 'unknown' | transloco }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- CREATED -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>
              {{ "created at pos" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              {{ formatDate(element.created_at) }}
            </td>
          </ng-container>

          <!-- ACTIONS -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"></th>

            <td mat-cell *matCellDef="let element" class="bb-actions-td">
              <div class="bb-action-dropdown dropdown">
                <button
                  class="bb-icon-btn"
                  type="button"
                  data-bs-toggle="dropdown"
                  [attr.aria-label]="'Actions' | transloco"
                >
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>

                <ul class="bb-dropdown-menu dropdown-menu">

                  @if(!hasSingleWarehouse){
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="showProducts(element.id)">
                        <i class="fa-solid fa-boxes-stacked"></i>

                        @if(isAdmin){
                          {{ "markas" | transloco }}
                        } @else {
                          {{ "show products" | transloco }}
                        }
                      </a>
                    </li>
                  }

                  @if(!hasSingleWarehouse){
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="createOrder(element.id)">
                        <i class="fa-solid fa-cart-plus"></i>
                        {{ "order from this products" | transloco }}
                      </a>
                    </li>
                  }

                  <li>
                    <a class="bb-dropdown-item dropdown-item" (click)="openDetailsPopup(element)">
                      <i class="fa-solid fa-circle-info"></i>
                      {{ "posdetails" | transloco }}
                    </a>
                  </li>

                  @if(canManageAppointments(element)){
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="openAppointments(element.id)">
                        <i class="fa-solid fa-calendar-days"></i>
                        {{ "clinicAppointments.menuAction" | transloco }}
                      </a>
                    </li>
                  }

                  @if(isAdmin){
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="edit(element)">
                        <i class="fa-solid fa-user-pen"></i>
                        {{ "edit or add users" | transloco }}
                      </a>
                    </li>
                  }

                  @if(superAdmin){
                    <li>
                      <a class="bb-dropdown-item dropdown-item text-danger" (click)="deleteitem(element.id)">
                        <i class="fa-solid fa-trash-can"></i>
                        {{ "Delete" | transloco }}
                      </a>
                    </li>
                  }

                </ul>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            [class.bb-bg-blue-soft]="activePosId == row.id"
          ></tr>

        </table>
      </div>

      @if(noData){
        <div class="bb-empty-state bb-text-center">
          <app-nodata></app-nodata>
        </div>
      }

      <div class="bb-flex bb-items-center bb-justify-center bb-gap-8 bb-mt-16 bb-text-muted bb-font-bold" *ngIf="isLoadingMore">
        <span></span>
        {{ "loading" | transloco }}
      </div>
    </div>

  </div>
</section>

<!-- Details Popup -->
<div *ngIf="detailsPopup" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-client-popup-card">

    <div class="bb-modal-header">
      <h4>{{ "posdetails" | transloco }}</h4>

      <button type="button" class="bb-modal-close" (click)="closeDetailsPopup()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bb-grid bb-gap-12" *ngIf="selectedPosDetails">

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-solid fa-phone"></i>
          {{ "phone" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          [class.bb-text-muted]="!selectedPosDetails.phonenumber"
          [href]="getPhoneHref(selectedPosDetails.phonenumber)"
        >
          {{ displayValue(selectedPosDetails.phonenumber) }}
        </a>
      </div>

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-solid fa-phone-volume"></i>
          {{ "Another Phone Number" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          [class.bb-text-muted]="!selectedPosDetails.another_phonenumber"
          [href]="getPhoneHref(selectedPosDetails.another_phonenumber)"
        >
          {{ displayValue(selectedPosDetails.another_phonenumber) }}
        </a>
      </div>

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-solid fa-globe"></i>
          {{ "website_link" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          target="_blank"
          [class.bb-text-muted]="!selectedPosDetails.website_link"
          [href]="getExternalHref(selectedPosDetails.website_link)"
        >
          {{ displayValue(selectedPosDetails.website_link) }}
        </a>
      </div>

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-brands fa-facebook"></i>
          {{ "facebook" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          target="_blank"
          [class.bb-text-muted]="!selectedPosDetails.facebook_link"
          [href]="getExternalHref(selectedPosDetails.facebook_link)"
        >
          {{ displayValue(selectedPosDetails.facebook_link) }}
        </a>
      </div>

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-brands fa-instagram"></i>
          {{ "instagram" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          target="_blank"
          [class.bb-text-muted]="!selectedPosDetails.instagram_link"
          [href]="getExternalHref(selectedPosDetails.instagram_link)"
        >
          {{ displayValue(selectedPosDetails.instagram_link) }}
        </a>
      </div>

      <div class="bb-card bb-p-12 bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap">
        <span class="bb-inline-flex bb-items-center bb-gap-8 bb-text-navy bb-font-bold">
          <i class="fa-brands fa-tiktok"></i>
          {{ "tiktok" | transloco }}
        </span>

        <a
          class="bb-link-action bb-truncate"
          target="_blank"
          [class.bb-text-muted]="!selectedPosDetails.tiktok_link"
          [href]="getExternalHref(selectedPosDetails.tiktok_link)"
        >
          {{ displayValue(selectedPosDetails.tiktok_link) }}
        </a>
      </div>

    </div>

    <div class="bb-modal-actions">
      <button type="button" (click)="closeDetailsPopup()" class="bb-btn bb-btn-secondary">
        {{ "close" | transloco }}
      </button>
    </div>

  </div>
</div>
